var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logout",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3359",
    "data-name": "Rectangle 3359",
    width: 16,
    height: 16,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M113.583,0a4.948,4.948,0,0,1,.762.21A2.476,2.476,0,0,1,115.919,2.6c.013,2.833,0,5.666,0,8.5,0,.766,0,1.531,0,2.3a2.558,2.558,0,0,1-2.111,2.556,2.672,2.672,0,0,1-.5.043q-2.578,0-5.155,0a2.545,2.545,0,0,1-2.56-2.141,4.084,4.084,0,0,1-.04-.669q-.009-.656,0-1.312a.751.751,0,0,1,1.34-.479.761.761,0,0,1,.159.495c0,.479,0,.958,0,1.437a1.076,1.076,0,0,0,1.164,1.171h5.046a1.073,1.073,0,0,0,1.155-1.163q0-5.335,0-10.67A1.073,1.073,0,0,0,113.267,1.5q-2.531,0-5.062,0a1.072,1.072,0,0,0-1.147,1.141c0,.594,0,1.187,0,1.781a.726.726,0,0,1-.631.706.738.738,0,0,1-.821-.5.685.685,0,0,1-.041-.213c0-.708-.023-1.418.024-2.123A2.527,2.527,0,0,1,107.761.031,1.32,1.32,0,0,0,107.9,0Z",
    transform: "translate(-99.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M0,88.882a1.476,1.476,0,0,1,.409-.575q1.225-1.216,2.443-2.44a.75.75,0,1,1,1.1,1.018c-.411.421-.831.833-1.248,1.249-.04.04-.088.073-.133.109l.015.045H9.009a.75.75,0,0,1,.088,1.5c-.057,0-.115,0-.172,0H2.56c.053.056.084.092.118.125.423.424.849.845,1.269,1.272a.733.733,0,0,1,.182.779.7.7,0,0,1-.587.5.692.692,0,0,1-.631-.2q-1.352-1.343-2.694-2.7A1.7,1.7,0,0,1,0,89.195Z",
    transform: "translate(0 -81.038)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.af5f086a4243c530a3164ee4f92dcd78.svg";
export { ForwardRef as ReactComponent };